export enum AlertIdsEnum {
  companyProfessionalPartWarning = 'companyProfessionalPartWarning',
  settings_reminders_info = 'settings_reminders_info',
  otherRevenueGermanCarUsage = 'otherRevenueGermanCarUsage',
  settingsGermanCarsList = 'settingsGermanCarsList',
  expenseSoftwareInvoice = 'expenseSoftwareInvoice',
  revenuesListPeppolOnboarding = 'revenuesListPeppolOnboarding',
  activateAccountableBankingCard = 'activateAccountableBankingCard',
  activateAccountableBankingCard2 = 'activateAccountableBankingCard2',
  walletBanner = 'WALLET_BANNER',
  finanzamtDocumentUploadBanner = 'FINANZAMT_DOCUMENT_UPLOAD_BANNER',
  addInvoiceIBANBanner = 'addInvoiceIBANBanner',
  E_InvoiceOnboardingAlert = 'E_InvoiceOnboardingAlert',
  expenseUtilityVehicle = 'expenseUtilityVehicle',
  expensePayWithAccountable = 'expensePayWithAccountable',
  // tooltips
  emailTrackingTooltip = 'emailTrackingTooltip',
  emailZugferdTooltip = 'emailZugferdTooltip',
  saveAndDownloadZugferdTooltip = 'saveAndDownloadZugferdTooltip',
  makeRecurringTooltip = 'makeRecurringTooltip',

  // documents repository
  repositoryDocumentFormInvoice = 'repositoryDocumentFormInvoice',
  taxesOnboardingAlert = 'taxesOnboardingAlert',
  repositoryMyMinFinConnectButtonTooltip = 'repositoryMyMinFinConnectButtonTooltip',

  peppolCountDownBanner = 'peppolCountDownBanner',
  // expert
  peppolRegistrationBanner = 'peppolRegistrationBanner',
  connectOverlayOnCustomersList = 'connectOverlayOnCustomersList',
  accountantEmailMarkedAsSent = 'accountantEmailMarkedAsSent',
  mfaRequiredBanner = 'mfaRequiredBanner',
  /** InterVAT banner — remind later (dismissedAlerts; cleared on logout). */
  intervatAccountantPermissionRemindLater = 'intervat_accountant_permission_remind_later',
  /** InterVAT banner — not_this_quarter / handle_myself (persists across logout until quarter changes or user clears storage). */
  intervatAccountantPermissionDismissPayload = 'intervat_accountant_permission_dismiss',
  expertIntervatTaxReviewIntroBanner = 'expert_intervat_tax_review_intro_banner',

  revenuesSelfBillingRejected = 'revenuesSelfBillingRejected',
  revenuesSelfBillingAccepted = 'revenuesSelfBillingAccepted',
  revenuesReverseChargeFranshiseeWarning = 'revenuesReverseChargeFranshiseeWarning',
}
